export const VACATION_POLICY_STRINGS = {
  TITLE: "Política de Vacaciones",

  DAYS_TEXT: "días",
  MONTHS_TEXT: "meses",

  LABEL_SENIORITY_REQUIREMENT: "Antigüedad mínima para disfrutar vacaciones",

  LABEL_ACCRUAL_METHOD: "Modalidad de disfrute",
  LABEL_ADVANCE_LEAVE: "Tomar días adelantados",

  HEADER_DEADLINE_TO_REQUEST: "Plazo para solicitar vacaciones",

  LABEL_ADVANCE_NOTICE_REQUIREMENT: "Fechas futuras",
  LABEL_ALLOW_PAST_DATES: "Fechas pasadas",

  RADIO_SENIORITY_ONE_YEAR: "1 año de servicio",
  RADIO_SENIORITY_FROM_FIRST_DAY: "A partir de",

  RADIO_ACCRUAL_ANNUAL_GRANTED:
    "Sólo días ganados (Otorgados oficialmente por cada año laboral)",
  RADIO_ACCRUAL_PROPORTIONAL:
    "Proporcional acumulado (Otorgados oficialmente más lo generado al día actual)",

  RADIO_ADVANCE_LEAVE_YES: "Sí, permitir saldo negativo",
  RADIO_ADVANCE_LEAVE_NO: "No",

  RADIO_ADVANCE_NOTICE_NONE: "Sin anticipación mínima",
  RADIO_ADVANCE_NOTICE_REQUIRED: "Requiere solicitarse con anticipación",

  RADIO_PAST_DATES_NO: "No se pueden registrar fechas pasadas",
  RADIO_PAST_DATES_YES: "Se pueden registrar fechas pasadas",

  INPUT_SENIORITY_DAYS_LABEL: "Días después de la fecha de ingreso",
  INPUT_SENIORITY_DAYS_PLACEHOLDER: "Ej. 90",
  INPUT_SENIORITY_DAYS_HELPER: "Mínimo 1 y máximo 364 días",

  INPUT_ADVANCE_NOTICE_LABEL: "Con al menos",
  INPUT_ADVANCE_NOTICE_PLACEHOLDER: "Ej. 5",
  INPUT_ADVANCE_NOTICE_HELPER: "Mínimo 1 y máximo 15 días",

  INPUT_PAST_DATES_LABEL: "Desde hoy hasta",
  INPUT_PAST_DATES_PLACEHOLDER: "Ej. 5",
  INPUT_PAST_DATES_HELPER: "Mínimo 1 y máximo 15 días",

  SELECT_ICON_LABEL: "Selecciona un ícono",

  BUTTON_UPDATE_LABEL: "Actualizar Datos",

  GET_DATA_ERROR_TITLE: "Error al obtener la política de vacaciones.",
  UPDATE_DATA_ERROR_TITLE: "Error al actualizar la política de vacaciones.",
  UPDATE_DATA_WARNING_TITLE: "Error al actualizar la política de vacaciones.",
  UPDATE_DATA_WARNING_MESSAGE:
    "Hubo un error al guardar los cambios. Por favor, intente nuevamente.",
  UPDATE_DATA_SUCCESS_TITLE:
    "Se guardaron las políticas de vacaciones correctamente.",
} as const;
